
import React from 'react';
import {FC} from 'react';
import {Link} from 'components/Header/navs';
import {Markdown} from 'components/Markdown';

import Stars from './svgs/stars.inline.svg';

import * as styles from './styles.module.scss';

type StyledLinkProps = {
	link: Link
}

const StyledLink: FC<StyledLinkProps> = ({link}) => {
	if (link.markdown) {
		return (
			<div className={styles.link}>
				<Markdown markdown={link.markdown} spanify />
				<Stars />
			</div>
		);
	}
	return <>{link.text}</>;
};

export default StyledLink;
